import SettingsAuth from './SettingsAuth.jsx';

export default SettingsAuth;
